export enum ContactSourceEnum {
  WEBSITE = 'website',
  PARTNER_PORTAL = 'partner-portal',
}

export interface ContactUsCreateModel {
  email: string
  firstName: string
  lastName: string
  text: string
  whoAmI: string
  source: ContactSourceEnum
}
